import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class ApiDataService extends StarbaseDataService<object> {
  protected _staleDataTimeout: number;
  protected _getOneUri = '/api/info';
  protected _getAllUri: string;
  protected _postUri: string;
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri: string;

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<object>): Observable<FilterParams<object>> {
    throw new Error('Method not implemented.');
  }

}
